<template>
  <span v-if="!filled" class="text-muted">{{ empty }}</span>
  <span v-else>
    {{ text }}
    <span v-if="spec.source === 'batch'" class="badge bg-light text-muted border ms-2">из партии</span>
  </span>
</template>

<script>
// Значение поля паспорта с пометкой источника: своё у ёмкости или взятое
// из партии. Что откуда — решает сервер и присылает в specs.
export default {
  name: 'SpecValue',
  props: {
    spec: { type: Object, default: () => ({}) },
    unit: { type: String, default: '' },
    empty: { type: String, default: 'Не указано' },
    format: { type: Function, default: null }
  },
  computed: {
    filled() {
      const value = this.spec && this.spec.value
      if (value === null || value === undefined || `${value}` === '') return false
      // Ноль в объёме или давлении означает «не заполнено»
      return !(this.unit && Number(value) === 0)
    },
    text() {
      const value = this.spec.value
      if (this.format) return this.format(value)
      if (!this.unit) return `${value}`
      // Хвостовые нули из DECIMAL: «23.90» → «23.9»
      const number = Number(value)
      return `${Number.isFinite(number) ? number : value} ${this.unit}`
    }
  }
}
</script>
